//TODO: Remove the unused interfaces after hooking up with backend data

enum ModalForm {
    ADD_DRIVER = 'addDriver',
    EDIT_DRIVER = 'editDriver',
    EMPTY = '',
}

export interface Option {
    id: number | string;
    name: string | number;
    disabled?: boolean;
}

export { ModalForm };
